import { FC } from 'react';
import styles from './index.module.scss';

/**
 * Props
 * @param title タイトルテキスト
 */
interface Props {
  title: string;
}

/**
 * 検索サイドバー・検索条件タイトル
 */
export const SearchConditionTitle: FC<Props> = ({ title }) => {
  return <h3 className={styles.searchCondition__title}>{title}</h3>;
};
